// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const MasterProductService = {};

MasterProductService.getMasterNatureOfCredit = function (data) {
  return lossClient({
    url: `/reference/natureofcredit`,
    method: "get",
  });
};

MasterProductService.getMasterTypeOfFinance = function (data) {
  return lossClient({
    url: `/reference/typeoffinance`,
    method: "get",
  });
};

MasterProductService.getMasterPartialPymentOpt = function (data) {
  return lossClient({
    url: `/reference/partialpaymentopt`,
    method: "get",
  });
};

MasterProductService.getMasterSecureType = function () {
  return lossClient({
    url: `/reference/securetype`,
    method: "get",
  });
};

MasterProductService.getCurrencyID = function () {
  // console.log("getCurrencyID service");
  return lossClient({
    url: `/Currency/items?pageSize=182&pageIndex=0`,
    method: "get",
  });
};

// MasterProductService.getMasterPaymentPriority = function () {
//   return lossClient({
//     url: `/reference/paymentpriority`,
//     method: "get",
//   });
// };

MasterProductService.getMasterLcCalcmethod = function () {
  return lossClient({
    url: `/reference/lccalcmethod`,
    method: "get",
  });
};

MasterProductService.getEventTransaction = function () {
  return lossClient({
    url: `/reference/eventtransaction`,
    method: "get",
  });
};

export default MasterProductService;
